import { ValeurPatrimoineSelectors } from '@get/store/selectors';
import { SelectorModel } from '@get/utils';

// tslint:disable-next-line: variable-name
export const ValeurPatrimoineModel: SelectorModel = {
  name: 'valeurPatrimoines',
  getSelector: ValeurPatrimoineSelectors.selectAllValeurPatrimoinesDictionary,
  isReady: ValeurPatrimoineSelectors.selectIsReadyValeurPatrimoine
};
